module.exports = __webpack_public_path__ + "assets/img/teacher (43).6be8bf45.png";